import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ChestReward, convertChestRewardListFromStrings } from '@/modules/picword/map/model/mixins';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';
import { picwordService } from '@/services/picword';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function usePicwordMapDetail() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: route.params.id,
        name: null,
        selectedIap: null,
        packageId: '',
        price: 0,
        totalLevel: 0,
        totalAccount: 0,
        chestByStar: '',
        chestRewardCredit: '',
        chestRewardHeart: '',
        chestRewardBooster: '',
        canEdit: false,
        canDelete: false,

        chestRewardList: [] as Array<ChestReward>
    });

    const fetch = crudAction.executeAction({
        request: () => picwordService.map.get(model.id),
        onSuccess: ({ data }) => {
            model.chestRewardList = convertChestRewardListFromStrings(
                data.chestByStar,
                data.chestRewardCredit,
                data.chestRewardHeart,
                data.chestRewardBooster
            );

            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_PICWORD.MAP.INDEX })
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: () => picwordService.map.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_PICWORD.MAP.INDEX })
        })
    };

    return { model, fetch, actions };
}
